import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Shop} from 'interfaces';
import {Button, Currency, Flex, Text} from 'components/UIKit';
import styles from '../../ListingCard.scss';
import * as locales from '../../locales';

interface CardCtaProps {
  shop: Shop;
  shopPath: string;
}

export function CardCtaComponent({shop, shopPath, i18n}: CardCtaProps & WithI18nProps) {
  return (
    <div className={styles.ctaWrapper}>
      <Flex className={styles.askingPrice} justifyContent="space-between">
        <Text
          type="smaller"
          text={i18n.translate('askingPrice')}
          className={styles.askingPriceLabel}
        />
        <Currency display="h3" emphasis value={shop.salePrice} />
      </Flex>
      <Button url={shopPath} label={i18n.translate('viewListing')} className={styles.cta} />
    </div>
  );
}

export const CardCta = withI18n({
  id: 'CardCta',
  fallback: locales.en,
})(CardCtaComponent);
